export default __webpack_public_path__ + "static/media/user1.d0d5b405.svg";